import { render, staticRenderFns } from "./ServiceDetailTabsIncidences.vue?vue&type=template&id=e9bc854e&scoped=true&"
import script from "./ServiceDetailTabsIncidences.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsIncidences.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsIncidences.vue?vue&type=style&index=0&id=e9bc854e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bc854e",
  null
  
)

export default component.exports